import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom, { Fragment } from "../../../dist/jsx-render/dom";
import { TextComponent } from "../TextComponent";
import { app } from "../../Frame/App";
import { SelectComponent } from "../../Components/SelectComponent";
import { RadioButtonComponent, RadioButtonOption } from "../RadioButtonComponent";
import { ValueFieldHelper } from "./ValueFieldHelper";
import { IConditionContext } from "./ConditionContext/Interfaces/IConditionContext";
import { IDropdown } from "../Interfaces/IDropdown";
import { Condition } from "../../Pages/Measure/VisibilityDependency/Condition";
import { DataTemplatesConditionContext } from "./ConditionContext/DataTemplatesConditionContext";
import { Template } from "../../Areas/Admin/Measures/TemplateEdit/Models/Template";

export type ConditionComponentProps = {
    model: Condition;
    context: IConditionContext;

    onDelete?: (model: Condition) => void;

    decimalChar?: number;

    showOnlyDatePicker?: boolean;

    template?: Template;
}

export class ConditionComponent extends JSXComponent {
    props: ConditionComponentProps;
    constructor(props: ConditionComponentProps) { super(props); }

    guid: string = app.createGuid();
    element: HTMLElement;

    fieldDropdownRef: IDropdown;
    allowFieldComparison: boolean = false;

    onFieldSelected = () => {
        // Reset selected Operator
        this.props.model["operator"] = undefined;
        this.createOperatorSelect();
        this.SetValueField();
    }

    createOperatorSelect = () => {
        let operators = this.props.context.getOperators(this.fieldDropdownRef);
        this.createOperatorSelectControl(operators);
    }

    public createOperatorSelectControl(operators: { name: string; value: string; }[]) {
        let fieldSelectContainer = this.element.querySelector(".operator") as HTMLDivElement;
        app.destroyDomChildren(fieldSelectContainer);

        fieldSelectContainer.appendChild(
            <SelectComponent
                model={this.props.model}
                field="operator"
                options={operators}
                additionalCssClasses="operatorSelect"
                name={Resources.Common.labelOperator} />
        );
    }

    SetValueField = () => {
        let fieldModel = this.fieldDropdownRef.getSelectedItem();
        let helper = new ValueFieldHelper();
        let valueType = this.props.context.getValueType(this.fieldDropdownRef);

        this.createControlsForValueType(valueType, fieldModel, helper);

    }

    onNextLinkSelected = (event: Event) => {
        let value = (event.target as HTMLInputElement).value;

        if (value == "0") {
            this.props.model.nextLink = "AND";
        } else {
            this.props.model.nextLink = "OR";
        }
    }

    onCompareWithSelected = (event: Event) => {
        this.SetValueField();
    }

    handleDelete = () => {
        app.destroyDomElements(this.element);

        if (this.props.onDelete) {
            this.props.onDelete(this.props.model);
        }
    }

    getElement = () => {
        this.fieldDropdownRef = this.props.context.getFieldControl();
        let helper = new ValueFieldHelper();

        this.element = <div className="condition">
            <div className="fas fa-times pointer close-expandable-button"></div>

            {this.fieldDropdownRef.render()}


            <div className="operator">
                <SelectComponent
                    model={this.props.model}
                    options={[]}
                    field="op"
                    name={Resources.Common.labelOperator}
                    disabled={true}
                />
            </div>

            {this.allowFieldComparison
                ? <div className="compare-wit">
                    <RadioButtonComponent model={this.props.model}
                        field="compareField"
                        options={[
                            { description: Resources.Common.compareFixed, value: 0 },
                            { description: Resources.Common.compareField, value: 1 },
                        ]}
                        inline={true}
                        isBoolean={true}
                        changeEvent={this.onCompareWithSelected}
                        name={Resources.Common.compareWith} />
                </div>
                : []}

            <div className="value">
                <TextComponent model={this.props.model}
                    field="value"
                    name={Resources.Common.labelValue}
                    showLabel={true}
                    additionalCssClasses="valueField" />
            </div>

            {this.allowFieldComparison
                ? <div className="compare-with-field"></div>
                : []}

            <div className="nextLink">
                <RadioButtonComponent
                    model={this.props.model}
                    field="nextLink"
                    options={[
                        { description: `${Resources.Common.labelLinkAnd}`, value: 0 },
                        { description: `${Resources.Common.labelLinkOr}`, value: 1 }
                    ]}
                    inline={true}
                    name={Resources.Common.labelLink}
                    changeEvent={this.onNextLinkSelected}
                    additionalCssClasses="next-link" />
            </div>
        </div>

        this.fieldDropdownRef.addEventListener(this.onFieldSelected);
    }

    /** Set values from model if present. */
    setValues = () => {
        if ((this.props.model.fieldId || this.props.model.fieldName)
            && this.props.context.selectedFieldExists()) {

            try {
                this.props.context.setField(false);

                this.SetValueField();
                this.createOperatorSelect();

                // load operators
                if (this.props.model.operator && this.props.model.operator.length > 0) {
                    let operatorSelect = this.element.querySelector(".operatorSelect select") as HTMLSelectElement;
                    operatorSelect.value = this.props.model.operator;
                }


                if (this.props.model.nextLink) {
                    if (this.props.model.nextLink == "AND") {
                        let radioButton = this.element.querySelector('input.next-link[type="radio"][value="0"]') as HTMLInputElement;
                        radioButton.checked = true;
                    } else if (this.props.model.nextLink == "OR") {
                        let radioButton = this.element.querySelector('input.next-link[type="radio"][value="1"]') as HTMLInputElement;
                        radioButton.checked = true;
                    }
                }
            } catch (err) {
                console.log(err);
            }
        }
    }

    public setDefaultNextLink = () => {
        if (!this.props.model.nextLink) {
            this.props.model.nextLink = "AND";
            var andButton = this.element.querySelector('.next-link[value="0"]') as HTMLInputElement;
            if (andButton) {
                andButton.setAttribute("checked", "true");
            }
        }
    }

    public createControlsForValueType(valueType: string, fieldModel: any, helper: ValueFieldHelper) {
        let compareWithFieldContainer = this.element.querySelector(".compare-with-field") as HTMLDivElement;

        if (compareWithFieldContainer && compareWithFieldContainer.childElementCount) {
            app.destroyDomChildren(compareWithFieldContainer);
        }

        if (this.allowFieldComparison && this.props.model.compareField) {
            let valueContainer = this.element.querySelector(".value") as HTMLDivElement;
            if (valueContainer && valueContainer.childElementCount) {
                app.destroyDomChildren(valueContainer);
            }

            if (this.props.template) {
                // TODO find a better way to get the comparefields
                let dropdown = this.props.context.getCompareFieldControl(this.props.model);
                compareWithFieldContainer.appendChild(<Fragment>{dropdown.render()}</Fragment>);
            }
        } else {

            switch (valueType) {
                case "string":
                    if (fieldModel.name && fieldModel.name.toLowerCase() != "statuseblockid" && fieldModel.name.toLowerCase() != "status")
                        helper.createTextField(this.element, this.props);
                    else
                        helper.createTemplateStatusControl(this.element, this.props);
                    break;
                case "int":
                    if (fieldModel.name && fieldModel.name.toLowerCase() == "statuseblockid" || fieldModel.name.toLowerCase() == "status") {
                        helper.createTemplateStatusControl(this.element, this.props);
                    } else {
                        helper.createIntControl(this.element, this.props);
                    }
                    break;
                case "multiline":
                    helper.createTextArea(this.element, this.props);
                    break;
                case "category":
                    helper.createCategoryControl(this.element, fieldModel.categoryId, this.props);
                    break;
                case "boolean":
                    helper.createRadioButtons(this.element, this.props);
                    break;
                case "double":
                    helper.createDecimalControl(this.element, this.props, fieldModel);
                    break;
                case "date":
                    if (this.props.showOnlyDatePicker) {
                        // For list views.
                        helper.createDateTimePicker(this.element, this.props);
                    }
                    else {
                        helper.createDateTimeControl(this.element, this.props);
                    }
                    break;
                case "user":
                    helper.createUserControl(this.element, this.props);
                    break;
                case "templateList":
                    helper.createTemplateListControl(this.element, this.props);
                    break;
                case "ampel":
                    helper.createAmpelControl(this.element, this.props);
                    break;
                case "parentstatus":
                    {
                        let statusFromParentUrl: string = this.props.context.getStatusFromParentSourceUrl(this.fieldDropdownRef.getSelectedItem());
                        helper.createParentStatusControl(this.element, statusFromParentUrl, this.props);
                    }
                    break;
                case "dataFromSubmeasures":
                    {
                        let selectedField = this.fieldDropdownRef.getSelectedItem();
                        helper.createDataFromSubmeasuresControl(this, this.element, this.props, selectedField);
                    }
                    break;
                default:
                    alert(Resources.Common.fieldTypeNotAsCondition);
                    // TODO
                    //this.fieldDropdownRef.setValue(undefined);
                    helper.clearValueArea(this.element);
            }

            if (valueType != "category") {
                helper.clearCategoryValue(this.props);
            }
        }
    }

    render() {
        if (this.props.context instanceof DataTemplatesConditionContext) this.allowFieldComparison = true;
        if (this.props.model.compareField == undefined || this.props.model.compareField == null) this.props.model.compareField = false;

        this.getElement();

        this.setValues();

        let closeButton = this.element.querySelector(".close-expandable-button");
        closeButton.addEventListener("click", this.handleDelete);

        return this.element;
    }

    private checkIfStringIsGuid(value: string): boolean {
        const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
        if (regexExp.test(value)) {
            return true;
        }
        else {
            return false;
        }
    }
}